import {
  DndSortZoneContextValue,
  DndSortZoneContext,
} from "./DndSortZoneContext";

/**
 * Tells items information about the zone they are contained within.
 * @param props - The props for the DndSortZoneContextProvider component
 * @param props.children - The child components to be rendered inside the context provider
 * @param props.id - The unique identifier for the drop zone
 * @param props.sortable - Whether the drop zone is sortable
 * @param props.sortedIds - The sorted IDs of the items in the drop zone
 * @param props.orientation - The orientation of the drop zone
 
 * @returns
 */
export default function DndSortZoneContextProvider(
  props: DndSortZoneContextValue,
) {
  return (
    <DndSortZoneContext.Provider value={props}>
      {props?.children}
    </DndSortZoneContext.Provider>
  );
}
